import { Link } from 'react-router-dom';
import type { Category } from '../types';

interface Props {
  category: Category;
  count: number;
}

export default function CategoryCard({ category, count }: Props) {
  return (
    <Link to={`/category/${category.slug}`} className="cat-card group p-4 sm:p-6">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-accent opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="w-9 h-9 sm:w-11 sm:h-11 rounded-md bg-accent-glow flex items-center justify-center text-[1.1rem] sm:text-[1.3rem]">
        {category.icon}
      </div>
      <div className="font-semibold text-xs sm:text-sm">{category.name}</div>
      <div className="text-[0.65rem] sm:text-xs text-text-muted mt-auto">
        {count} {count === 1 ? 'listing' : 'listings'}
      </div>
    </Link>
  );
}